import { BASE_URL, post } from "./requests"

const CREATE_EVENT = `${BASE_URL}/events/create`

export const createEvent = async (event: EventServerView) => {
  const res = await post(CREATE_EVENT, event)
  return res
}
